import apiService from '../Api'
import { BlogPost, BlogPostComplete, KnowledgeArea } from './types'

export interface IBlogPostFields {
  title: string
  header: string
  body: string
  popular: boolean
  knowledge_areas: number[]
}

export class BlogPostService {
  async list(queryParams: { search: string; page_size: string; page: number }): Promise<{
    data: BlogPost[]
    current_page: number
    per_page: number
    total: number
    total_filtered: number
  }> {
    const params = new URLSearchParams()
    params.append('search', queryParams.search)
    params.append('page_size', queryParams.page_size)
    params.append('page', queryParams.page.toString())

    return apiService.get('/blog-posts', { params }).then((response) => response.data)
  }

  async get(id: number): Promise<BlogPostComplete> {
    return apiService.get(`/blog-posts/${id}`).then((response) => response.data)
  }

  async delete(id: number): Promise<void> {
    return apiService.delete(`/blog-posts/${id}`)
  }

  async getKnowledgeAreas(): Promise<KnowledgeArea[]> {
    return apiService.get('/knowledge-areas').then((response) => response.data.areas)
  }

  async create(form: IBlogPostFields): Promise<BlogPostComplete> {
    const formData = new FormData()
    formData.append('title', form.title)
    formData.append('header', form.header)
    formData.append('body', form.body)
    formData.append('popular', form.popular ? '1' : '0')

    form.knowledge_areas.forEach((areaId) => {
      formData.append('knowledge_areas[]', areaId.toString())
    })

    return apiService.post('/blog-posts', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }

  async update(id: number, form: IBlogPostFields): Promise<BlogPostComplete> {
    const formData = new FormData()
    formData.append('_method', 'PUT')
    formData.append('title', form.title)
    formData.append('header', form.header)
    formData.append('body', form.body)
    formData.append('popular', form.popular ? '1' : '0')

    form.knowledge_areas.forEach((areaId) => {
      formData.append('knowledge_areas[]', areaId.toString())
    })

    return apiService.post(`/blog-posts/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}
